// src/hooks/useIngredients.js — ohapotato v2026.10.36
import { useState, useMemo } from 'react';
import { INGREDIENTS, STAPLES } from '../data/ingredients';

const ALL = [...STAPLES, ...INGREDIENTS];
const STAPLE_IDS = new Set(STAPLES.map(s => s.id));
// Staples are pre-selected by default
const DEFAULT_SELECTED = new Set(STAPLE_IDS);

export function useIngredients() {
  const [selected, setSelected] = useState(new Set(DEFAULT_SELECTED));
  const [category, setCategory] = useState('all');
  const [search, setSearch]     = useState('');

  const toggle = (id) =>
    setSelected(prev => {
      const next = new Set(prev);
      next.has(id) ? next.delete(id) : next.add(id);
      return next;
    });

  const remove = (id) =>
    setSelected(prev => { const n = new Set(prev); n.delete(id); return n; });

  // Clear only non-staple selections; restore all staples to selected
  const clear = () => setSelected(new Set(DEFAULT_SELECTED));

  // Select by ingredient label names (PantryIQ / suggestion)
  const selectMultiple = (labels) => {
    const ids = ALL
      .filter(i => labels.some(l => l.toLowerCase() === i.label.toLowerCase()))
      .map(i => i.id);
    setSelected(prev => {
      const next = new Set(prev);
      ids.forEach(id => next.add(id));
      return next;
    });
  };

  const filtered = useMemo(() =>
    INGREDIENTS.filter(i => {
      const matchCat    = category === 'all' || i.cat === category;
      const matchSearch = i.label.toLowerCase().includes(search.toLowerCase());
      return matchCat && matchSearch;
    }),
  [category, search]);

  const selectedList = useMemo(() =>
    ALL.filter(i => selected.has(i.id)),
  [selected]);

  // Count of non-staple selections — used for the 2-ingredient minimum
  const nonStapleCount = useMemo(() =>
    [...selected].filter(id => !STAPLE_IDS.has(id)).length,
  [selected]);

  return {
    selected, toggle, remove, clear, selectMultiple,
    category, setCategory, search, setSearch,
    filtered, selectedList,
    nonStapleCount, STAPLE_IDS,
  };
}
